import React from "react";
import { PARTNERS } from "../../../constant/CarouselData";
import Eyebrow from "../../common/Eyebrow";

const BrandPartners = () => {
  return (
    <section className="overflow-hidden bg-white px-6 py-20">
      <div className="mx-auto max-w-6xl">
      <div className="text-center">
        <Eyebrow>Ecosystem</Eyebrow>
      </div>
      <h2 className="mt-3 text-center text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">Brands & Partners</h2>
      <p className="mt-4 text-center text-slate-600">
        Trusted by Leading Brands and Partners
      </p>

      <div className="relative mt-10 overflow-hidden before:absolute before:inset-y-0 before:left-0 before:z-10 before:w-16 before:bg-gradient-to-r before:from-white before:to-transparent after:absolute after:inset-y-0 after:right-0 after:z-10 after:w-16 after:bg-gradient-to-l after:from-white after:to-transparent">
        <div className="animate-scroll flex items-center gap-5">
          {PARTNERS.concat(PARTNERS).map((tech, index) => {
            const imageSrc = tech.imageUrl
              ? require(`../../../assets/Partners/${tech.imageUrl}`)
              : require(`../../../assets/Partners/cisco.png`);

            return (
              <div
                key={index}
                className="flex h-24 w-36 flex-shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 p-4"
              >
                <img
                  src={imageSrc}
                  alt={tech.name}
                  className="h-16 w-24 object-contain transition duration-300 hover:scale-110"
                />
              </div>
            );
          })}
        </div>
      </div>
      </div>
    </section>
  );
};

export default BrandPartners;
